import { request } from "./client";

/**
 * League announcements: an organizer emails everyone in their league.
 * Admin/owner only. The server enforces the limits and decides who is reached.
 */

/**
 * Everything the compose screen needs.
 * @returns {Promise<{
 *   limits: { subject: number, message: number, maxLinks: number, maxRecipients: number, perDay: number, perWeek: number },
 *   mergeFields: { name: string, description: string, example: string }[],
 *   allowance: { remaining: number, nextAllowedAt: string | null },
 *   audience: { total: number, willReceive: number, skipped: number, tooMany: boolean },
 *   history: { id: string, subject: string, createdAt: string, sentBy: string | null, recipientCount: number, queuedCount: number, skippedCount: number }[],
 * }>}
 */
export const getAnnouncementData = async (leagueId) => request(`/leagues/${leagueId}/announcements`);

/** Renders the draft as a player would see it. Returns { valid, errors, subject?, html?, text? }. */
export const previewAnnouncement = async (leagueId, { subject, message }) =>
  request(`/leagues/${leagueId}/announcements/preview`, { method: "POST", body: JSON.stringify({ subject, message }) });

/** Emails the draft to the signed-in organizer only. Returns { sent, to?, message }. */
export const sendAnnouncementTest = async (leagueId, { subject, message }) =>
  request(`/leagues/${leagueId}/announcements/test`, { method: "POST", body: JSON.stringify({ subject, message }) });

/**
 * Sends to the league. `id` is chosen once per compose screen (a UUID), so a double-click or a retry
 * can't email everyone twice. Returns { announcementId, recipientCount, queuedCount, skippedCount, alreadySent }.
 */
export const sendAnnouncement = async (leagueId, { id, subject, message }) =>
  request(`/leagues/${leagueId}/announcements`, { method: "POST", body: JSON.stringify({ id, subject, message }) });
